module.exports = "<div class=abs-full-size obs-map-manager obs-commune-manager> <tl-panel-layout panel-opened class=observatoire-carte> <tl-panel-left> <obs-commune-panel></obs-commune-panel> </tl-panel-left> <tl-panel-right autosizing-container sizable-container> <obs-leaflet-map obs-commune-map add-taelys-watermark add-presentation-button add-social-buttons></obs-leaflet-map> </tl-panel-right> </tl-panel-layout> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/apps/observatoire/ng/communes/communes.html
// module id = 3574
// module chunks = 12